<template>
  <div class="section-main__warp combustibleGasManage-page">
    <ioc-table
      ref="crud"
      :data="tableData"
      :option="option"
      :page="page"
      @search-change="handleSearchChange"
      @search-reset="handleSearchReset"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
      <template slot="search_deviceWorkGroupName">
        <el-input
          :disabled="true"
          v-model="queryForm.deviceWorkGroupName"
        ></el-input>

        <el-button type="text" @click="showTree" class="select-btn"
          >请选择</el-button
        >
      </template>
      <template slot="search_submitTime">
        <div>
          <el-date-picker
            type="datetime"
            placeholder="请选择开始时间"
            v-model="queryForm.beginTime"
            style="width: 182px"
          ></el-date-picker>
          <span style="padding: 0 5px">至</span>
          <el-date-picker
            type="datetime"
            placeholder="请选择结束时间"
            v-model="queryForm.endTime"
            style="width: 182px"
          ></el-date-picker>
        </div>
      </template>
      <template slot="concentration" slot-scope="scope">
        <div
          :class="[
            scope.row.status == 'normal' ? 'safeFontColor' : 'warnFontColor',
          ]"
        >
          {{ scope.row.concentration }}
        </div>
      </template>
      <template slot="status" slot-scope="scope">
        <div :class="[scope.row.status == 'normal' ? 'safe' : 'warn', 'state']">
          {{ queryDics(scope.row.status) }}
        </div>
      </template>
      <template slot="submitTime" slot-scope="scope">
        <div class="safeFontColor">
          {{ scope.row.submitTime }}
        </div>
      </template>
    </ioc-table>
    <el-dialog
      title="选择设备组"
      :visible.sync="groupDialog"
      width="500px"
      v-dialogDrag
    >
      <div class="device-group_body">
        <div class="group-search">
          <el-input
            placeholder="输入设备组名称进行查找"
            v-model="deviceGroupName"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="filterNode"
            ></el-button>
          </el-input>
        </div>
        <el-scrollbar height="90%">
          <el-tree
            :data="deviceData"
            :props="props"
            :filter-node-method="filterNode"
            ref="tree"
            @node-click="handleDeviceClick"
          >
          </el-tree>
        </el-scrollbar>
      </div>
      <div slot="footer">
        <el-button type="default" @click="cancel">取消</el-button>
        <el-button type="primary" @click="confirm">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import tableOption from "../config/table";
import { api } from "../api";
import { Dic } from "$utils";
import utils from "@src/common/utils";
import { parseTime } from "@src/common/filters";
export default {
  data() {
    return {
      tableData: [],
      page: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      option: tableOption(this),
      queryForm: {
        beginTime: "",
        endTime: "",
        pageSize: 10,
        pageNum: 1,
        parentDeviceName: "",
        statusList: [],
      },
      status: [
        {
          label: "正常",
          value: "normal",
        },
        {
          label: "通信故障",
          value: "comm-error",
        },
        {
          label: "感器故障",
          value: "dev-error",
        },
        {
          label: "告警",
          value: "alarm",
        },
      ],
      deviceData: [],
      props: {
        children: "children",
        label: "label",
        id: "id",
      },
      deviceGroupName: "",
      groupDialog: false,
    };
  },
  watch: {
    deviceGroupName(val) {
      this.$refs.tree.filter(val);
    },
  },
  mounted() {
    this.getList();
    this.queryDeviceWorkGroup();
  },
  methods: {
    cancel() {
      this.queryForm.deviceWorkGroupCode = "";
      this.queryForm.deviceWorkGroupName = "";
      this.groupDialog = false;
    },
    confirm() {
      this.groupDialog = false;
    },
    showTree() {
      this.groupDialog = true;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    handleDeviceClick(node) {
      this.queryForm.deviceWorkGroupCode = node.id;
      this.queryForm.deviceWorkGroupName = node.label;
    },
    queryDics(value) {
      return Dic.findByValue("SENU11001", value, false);
    },
    queryDeviceWorkGroup() {
      this.$fetch(api.queryDeviceWorkGroup, { deviceType: "22" }).then(
        (res) => {
          if (res.success) {
            this.deviceData = this.menusDataPro(res.returnObj);
            console.log(this.deviceData, "0000000000");
          }
        }
      );
    },
    //递归树结构
    menusDataPro(data) {
      const self = this;
      const result = [];
      if (data !== null) {
        data.forEach(function (item) {
          const entity = {};
          entity.id = item.deviceWorkGroupCode;
          entity.label = item.deviceWorkGroupName;
          entity.parentCode = item.parentCode;
          entity.isLeaf = !item.hasLeaf || !item.subBuildingList;
          if (item.deviceWorkGroupChildren) {
            entity.children = self.menusDataPro(item.deviceWorkGroupChildren);
          }
          result.push(entity);
        });
        return result;
      }
    },
    getList() {
      // let params = {
      //   deviceName: this.queryForm.deviceName,
      //   beginTime: this.queryForm.beginTime,
      //   endTime: this.queryForm.endTime,
      //   statusList: this.queryForm.statusList,
      // };
      this.queryForm.pageSize = this.page.pageSize;
      this.queryForm.pageNum = this.page.currentPage;
      this.queryForm.beginTime
        ? (this.queryForm.beginTime = parseTime(this.queryForm.beginTime))
        : "";
      this.queryForm.endTime
        ? (this.queryForm.endTime = parseTime(this.queryForm.endTime))
        : "";
      this.$fetch(api.queryGasOperationList, this.queryForm).then((res) => {
        if (res.success) {
          this.tableData = res.returnObj.list;
          this.page.total = res.returnObj.total;
        }
      });
    },
    handleSearchChange(data) {
      this.queryForm.parentDeviceName = data.parentDeviceName
        ? data.parentDeviceName
        : "";
      this.queryForm.statusList = data.statusList;
      this.getList();
    },
    handleSearchReset() {
      this.queryForm = {};
      this.getList();
    },
    handleSizeChange(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.getList();
    },
  },
};
</script>
<style lang="scss">
.device-group_body .is-current {
  background: #409eff;
}
</style>
<style scoped lang="scss">
.select-btn {
  position: absolute;
  right: 0;
}
.device-group_body {
  margin: 10px;
  height: 260px;
  .group-search {
    margin-bottom: 10px;
  }
  .el-tree {
    height: 240px;
  }
}
.combustibleGasManage-page {
  width: 100%;
  .safeFontColor {
    color: rgba(0, 240, 0, 1);
  }
  .warnFontColor {
    color: rgb(243, 35, 39);
  }
  .state {
    color: #fff;
    border-radius: 5px;
  }
  .safe {
    background: rgba(68, 157, 68, 1);
  }
  .warn {
    background: rgba(255, 69, 71, 1);
  }
}
</style>

